import {
    getBlankOrderInformation,
    OrderInformation
} from '../../../model/order-information.model';
import * as actions from './order-checkout.actions';
import { ValidationStatus } from './order-checkout.actions';
import { UserDetails } from '../../shared/model';
import { VoucherReference } from '@app/order-checkout/store';

export interface State {
    orderInformation: OrderInformation;
    sameInvoiceAddressSwitch: boolean;
    validationStatus: ValidationStatus;
    validOrderInformationSet: boolean;
    userDetails: UserDetails;
    invalidPage: string;
    errors: string[];
    voucherReference: VoucherReference;
}

const initialState = {
    orderInformation: getBlankOrderInformation(),
    sameInvoiceAddressSwitch: true,
    validationStatus: ValidationStatus.IDLE,
    validOrderInformationSet: false,
    userDetails: null,
    errors: [],
    invalidPage: null,
    voucherReference: null
};

export const getOrderCheckoutInformation = (state: State) => state.orderInformation;
export const getSameInvoiceAddressSwitch = (state: State) => state.sameInvoiceAddressSwitch;
export const isValidOrderInformationSet = (state: State) => state.validOrderInformationSet;
export const getValidationStatus = (state: State) => state.validationStatus;
export const getErrors = (state: State) => state.errors;
export const getInvalidPage = (state: State) => state.invalidPage;
export const getVoucherReference = (state: State) => state.voucherReference;

// case reducers
const updateOrderInfoVoucherReference = (state: OrderInformation, ref: VoucherReference) => {
    const { reference: voucherReference, isValid } = ref;
    const valid = !!isValid && !!voucherReference;
    if (valid) {
        return { ...state, voucherReference };
    } else {
        return { ...state, voucherReference: null };
    }
};

export function reducer(state = initialState, action: actions.OrderCheckoutActions) {
    switch (action.type) {
    case actions.ADD_ORDER_INFORMATION:
        return {
            ...state,
            orderInformation: action.orderInformation,
        };
    case actions.UPSERT_ORDER_INFORMATION:
        return {
            ...state,
            orderInformation: { ...state.orderInformation, ...action.orderInformation }
        };
    case actions.RESET_ORDER_INFORMATION:
        return {
            ...state,
            orderInformation: getBlankOrderInformation()
        };
    case actions.UPDATE_ADDRESS:
        let updatedOrderInformation;
        if (action.addressType === 'Delivery') {
            updatedOrderInformation = {
                ...state.orderInformation,
                deliveryAddress: { ...action.address }
            };
        } else {
            updatedOrderInformation = {
                ...state.orderInformation,
                invoiceAddress: { ...action.address }
            };
        }
        return {
            ...state,
            orderInformation: { ...updatedOrderInformation }
        };
    case actions.UPDATE_SAME_INVOICE_ADDRESS:
        return {
            ...state,
            sameInvoiceAddressSwitch: action.sameInvoiceAddressSwitch
        };
    case actions.VALID_ORDER_INFORMATION_SET:
        return {
            ...state,
            validOrderInformationSet: action.payload
        };
    case actions.VALIDATE:
        return {
            ...state,
            validationStatus: ValidationStatus.VALIDATING
        };
    case actions.VALIDATE_SUCCESS:
        return {
            ...state,
            validationStatus: ValidationStatus.VALID
        };
    case actions.VALIDATE_FAIL:
        return {
            ...state,
            validationStatus: ValidationStatus.INVALID
        };
    case actions.VALIDATE_RESET:
        return {
            ...state,
            validationStatus: ValidationStatus.IDLE
        };
    case actions.SET_ERROR:
        return {
            ...state,
            errors: action.payload
        };
    case actions.SET_INVALID_PAGE:
        return {
            ...state,
            invalidPage: action.payload
        };
    case actions.SET_VOUCHER_REFERENCE:
        return {
            ...state,
            orderInformation: updateOrderInfoVoucherReference(state.orderInformation, action.voucherReference),
            voucherReference: action.voucherReference
        };
    default:
        return state;
    }
}
